import { GenericSectionThemeType, MenuItemType } from '@utils/types'
import { CataloghiBlock } from '@components/molecules'
import { GenericSection } from '@components/organisms'
import styles from './CataloghiSection.module.sass'

interface Props {
  refId?: string
  item: MenuItemType
  theme?: GenericSectionThemeType
  editMode?: boolean
  className?: string
}

const CataloghiSection = (props: Props) => {
  const {
    refId = undefined,
    item = undefined,
    theme = 'neutral20',
    editMode = false,
    className = '',
  } = props

  return editMode || (Array.isArray(item.children) && item?.children?.length) ? (
    <GenericSection
      refId={refId}
      item={item}
      theme={theme}
      className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}
    >
      {editMode && !Array.isArray(item.children) ? (
        <div className={styles.listPb}>{item.children}</div>
      ) : item?.children?.length > 0 ? (
        <div className={styles.list}>
          {item.children.map((x) => (
            <CataloghiBlock item={x} />
          ))}
        </div>
      ) : (
        <></>
      )}
    </GenericSection>
  ) : (
    <></>
  )
}

export default CataloghiSection
